module.exports = __webpack_public_path__ + "img/cost_reduction.6ef39803.svg";